import { EntityI } from '../interfaces/Entity';
import { EntityType } from './EntityType';

export class BaseEntity implements EntityI {
  constructor(public entityType: EntityType) {}
}
